module.exports = __webpack_public_path__ + "butterfly.jpg?a6fcc8405b18086b3837904776a5c2f3";